"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSlidesPerViewWithBreakpoints = void 0;
var _esToolkit = require("es-toolkit");
var _isEmpty = _interopRequireDefault(require("es-toolkit/compat/isEmpty"));
var _getSlidesPerView = require("./getSlidesPerView");
var _isBreakpointActive = require("./isBreakpointActive");
var _parseMediaQuery = require("./parseMediaQuery");
/**
 * Determines slides per view based on active breakpoints for current viewport width.
 * Prioritizes min-width queries and higher specificity values.
 */
const getSlidesPerViewWithBreakpoints = ({
  slider,
  viewportWidth,
  useBreakpointsPerView = false
}) => {
  if (!slider?.breakpoints || !useBreakpointsPerView) {
    return (0, _getSlidesPerView.getSlidesPerView)(slider);
  }
  const {
    breakpoints
  } = slider;
  const activeBreakpoints = Object.entries(breakpoints).filter(([query]) => (0, _isBreakpointActive.isBreakpointActive)(query, viewportWidth)).map(([query, settings]) => {
    const parsed = (0, _parseMediaQuery.parseMediaQuery)(query); // Extract width value and type (min-width or max-width).
    const specificity = parsed?.value ?? 0; // Extract width value for priority. It is used for sorting.
    const isMinWidth = query.includes('min-width'); // Check if query is a min-width.

    return {
      query,
      perView: (0, _getSlidesPerView.getSlidesPerView)(settings),
      specificity,
      isMinWidth
    };
  });
  if ((0, _isEmpty.default)(activeBreakpoints)) {
    return (0, _getSlidesPerView.getSlidesPerView)(slider);
  }

  // Sort by priority: min-width first, then by specificity (desc for min-width, asc for others)
  const sortedBreakpoints = (0, _esToolkit.orderBy)(activeBreakpoints, [item => item.isMinWidth ? 0 : 1, item => item.isMinWidth ? -item.specificity : item.specificity], ['asc', 'asc']);
  return sortedBreakpoints[0]?.perView ?? (0, _getSlidesPerView.getSlidesPerView)(slider);
};
exports.getSlidesPerViewWithBreakpoints = getSlidesPerViewWithBreakpoints;
//# sourceMappingURL=getSlidesPerViewWithBreakpoints.js.map